import { Routes, Route } from 'react-router-dom';
import PortalLayout from '../shared/components/PortalLayout';
import {
  useAuth, userIsAdmin, userIsSupervisor, userIsEngineer, userIsManager, userIsReviewer,
  userIsSocio, userIsAccountant,
} from '../context/AuthContext';
import RequestListPage from './pages/RequestListPage';
import RequestCreatePage from './pages/RequestCreatePage';
import RequestDetailPage from './pages/RequestDetailPage';
import PTOReviewListPage from './pages/PTOReviewListPage';
import AdminCalendarPage from './pages/AdminCalendarPage';
import BalancesPage from './pages/BalancesPage';

export default function VacationPortal() {
  const { user } = useAuth();
  // 🔴 V62 — EL SEXTO BLOQUEADOR. Hasta V61 esto era `userIsSupervisor(user)`, o sea
  // supervisor ‖ admin: el INGENIERO y el SOCIO —los dos que efectivamente aprueban en la
  // cadena (V60)— NO podían entrar a /vacaciones/revision. El módulo se podía destrabar
  // entero y los aprobadores seguirían sin llegar a su cola.
  // ⚠ Es un gate de NAVEGACIÓN, no de autorización: quién puede aprobar cada solicitud lo
  // decide la ganga de ESE proyecto en el backend (`canUserApprove`). Acá solo se decide
  // quién ve la pantalla.
  // 🔴 Solo los DOS que aprueban, más admin que mira (corregido en el pase visual de V62:
  // el supervisor tenía el link y la cola le salía vacía, porque no participa de esta
  // cadena). Espeja el gate del sidebar en PortalLayout — si divergen, o hay un link a
  // una ruta muerta, o una pantalla alcanzable sin link.
  const puedeAprobar = userIsEngineer(user) || userIsSocio(user) || userIsAdmin(user);
  // El calendario es más amplio: sirve para planificar cobertura, no para aprobar.
  const puedeVerCalendario = puedeAprobar || userIsSupervisor(user)
    || userIsManager(user) || userIsReviewer(user);
  // V62 — el dashboard AMPLIADO (saldos + costo). Gate por rol, espejado en el sidebar.
  const puedeVerSaldos = userIsSocio(user) || userIsAccountant(user) || userIsAdmin(user);

  return (
    <PortalLayout activeModule="vacaciones">
      <Routes>
        {/* Employee routes (everyone) */}
        <Route index element={<RequestListPage />} />
        <Route path="nueva" element={<RequestCreatePage />} />
        <Route path=":id" element={<RequestDetailPage />} />

        {/* Cola de aprobación — Ingeniero(a), Socio(a) y admin */}
        {puedeAprobar && <Route path="revision" element={<PTOReviewListPage />} />}
        {puedeVerCalendario && <Route path="calendario" element={<AdminCalendarPage />} />}
        {puedeVerSaldos && <Route path="balances" element={<BalancesPage />} />}
      </Routes>
    </PortalLayout>
  );
}
